import axios from "axios";
import toast from "react-hot-toast";

// Create an Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Replace with your API URL
  timeout: 60000, // Timeout for requests
});

// Request interceptor to set appropriate Content-Type header dynamically
apiClient.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    // Delete Content-Type to let Axios & browser generate multipart/form-data boundary automatically
    if (config.headers) {
      delete config.headers["Content-Type"];
      delete config.headers["content-type"];
    }
  } else if (config.headers && !config.headers["Content-Type"] && !config.headers["content-type"]) {
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});

// Response interceptor for handling responses
apiClient.interceptors.response.use(
  (response) => {
    if (response.config.method !== 'get' && response.data?.success) {
      const successMessage = response.data?.message || "Operation successful!";
      toast.success(successMessage, { duration: 4000 });
    }
    return response;
  },
  (error) => {
    if (error.config?.method !== 'get') {
      const backendMessage =
        error.response?.data?.error?.message || 
        error.response?.data?.message || 
        error.message || 
        "Something went wrong";
      toast.error(backendMessage);
    }
    return Promise.reject(error);
  }
);

// Function to make requests with custom headers
export const apiRequest = (method, url, data = {}, headers = null) => {
  const reqHeaders = { ...(headers || {}) };
  if (data instanceof FormData) {
    delete reqHeaders["Content-Type"];
    delete reqHeaders["content-type"];
  }
  return apiClient({
    method,
    url,
    data,
    headers: reqHeaders,
  });
};

export default apiClient;
